import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/login/page";
import ForgotPasswordPage from "../pages/forgot-password/page";
import ResetPasswordPage from "../pages/reset-password/page";
import DashboardPage from "../pages/dashboard/page";
import LeadsPage from "../pages/leads/page";
import LeadDetailPage from "../pages/leads/detail/page";
import ImportLeadsPage from "../pages/leads/import/page";
import PipelinePage from "../pages/pipeline/page";
import CallsPage from "../pages/calls/page";
import WhatsAppPage from "../pages/whatsapp/page";
import ReportsPage from "../pages/reports/page";
import IntegrationsPage from "../pages/integrations/page";
import ActivityFeedPage from "../pages/activity/page";
import SettingsOverviewPage from "../pages/settings/page";
import UsersPage from "../pages/settings/users/page";
import PositionsPage from "../pages/settings/positions/page";
import TeamsPage from "../pages/settings/teams/page";
import CompanyProfilePage from "../pages/settings/company/page";
import AssignmentPage from "../pages/settings/assignment/page";
import ScoringConfigPage from "../pages/settings/scoring/page";
import IndustryConfigPage from "../pages/settings/industry/page";
import ProjectsSettingsPage from "../pages/settings/projects/page";
import WorkflowsPage from "../pages/settings/workflows/page";
import WorkflowBuilderPage from "../pages/settings/workflows/builder/page";
import ProfilePage from "../pages/settings/profile/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";
import AdminRoute from "../components/feature/AdminRoute";
import SuperAdminRoute from "../components/feature/SuperAdminRoute";
import QuotationsPage from "../pages/quotations/page";
import NewQuotationPage from "../pages/quotations/new/page";
import EditQuotationPage from "../pages/quotations/edit/page";
import QuotationDetailPage from "../pages/quotations/detail/page";
import QuotationTemplatesPage from "../pages/quotations/templates/page";
import CampaignsPage from "../pages/campaigns/page";
import NewCampaignPage from "../pages/campaigns/new/page";
import CampaignResultsPage from "../pages/campaigns/results/page";
import BotIdentityPage from "../pages/settings/ai-agent/page";
import KnowledgeBasePage from "../pages/settings/knowledge-base/page";
import LeadCapturePage from "../pages/lead-capture/page";
import NewLeadCaptureFormPage from "../pages/lead-capture/new/page";
import EditLeadCaptureFormPage from "../pages/lead-capture/edit/page";
import FormSubmissionsPage from "../pages/lead-capture/submissions/page";
import ProjectsPage from "../pages/projects/page";
import ProjectDetailPage from "../pages/projects/detail/page";
import BranchPage from "../pages/settings/branch/page"
import PublicLeadCaptureFormPage from "../pages/lead-capture/public/page";
const routes: RouteObject[] = [
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/forms/:formId",
    element: <PublicLeadCaptureFormPage />,
  },
  {
    path: "/lead-capture/view/:formId",
    element: <PublicLeadCaptureFormPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPasswordPage />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },

  //  {
  //   path: "/demo",
  //   element: (
  //     <ProtectedRoute>
  //       <Demo />
  //     </ProtectedRoute>
  //   ),
  // },

  {
    path: "/activity",
    element: (
      <ProtectedRoute>
        <ActivityFeedPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/leads",
    element: (
      <ProtectedRoute>
        <LeadsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/leads/:id",
    element: (
      <ProtectedRoute>
        <LeadDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/leads/import",
    element: (
      <ProtectedRoute>
        <ImportLeadsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/pipeline",
    element: (
      <ProtectedRoute>
        <PipelinePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/quotations",
    element: (
      <ProtectedRoute>
        <QuotationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/quotations/new",
    element: (
      <ProtectedRoute>
        <NewQuotationPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/quotations/:id/edit",
    element: (
      <ProtectedRoute>
        <EditQuotationPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/quotations/templates",
    element: (
      <ProtectedRoute>
        <QuotationTemplatesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/quotations/:id",
    element: (
      <ProtectedRoute>
        <QuotationDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/calls",
    element: (
      <ProtectedRoute>
        <CallsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/campaigns",
    element: (
      <ProtectedRoute>
        <CampaignsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/campaigns/new",
    element: (
      <ProtectedRoute>
        <NewCampaignPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/campaigns/:id",
    element: (
      <ProtectedRoute>
        <CampaignResultsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/lead-capture/new",
    element: (
      <ProtectedRoute>
        <NewLeadCaptureFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/lead-capture/:formId/submissions",
    element: (
      <ProtectedRoute>
        <FormSubmissionsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/lead-capture/:formId",
    element: (
      <ProtectedRoute>
        <EditLeadCaptureFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/lead-capture",
    element: (
      <ProtectedRoute>
        <LeadCapturePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/projects/:projectId",
    element: (
      <ProtectedRoute>
        <ProjectDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/projects",
    element: (
      <ProtectedRoute>
        <ProjectsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/whatsapp",
    element: (
      <ProtectedRoute>
        <WhatsAppPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports",
    element: (
      <ProtectedRoute>
        <ReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/integrations",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <IntegrationsPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <SettingsOverviewPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/users",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <UsersPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/branchs",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <BranchPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/positions",
    element: (
      <ProtectedRoute>
        <SuperAdminRoute>
          <PositionsPage />
        </SuperAdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/teams",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <TeamsPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/company",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <CompanyProfilePage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/assignment",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <AssignmentPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/scoring",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <ScoringConfigPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/industry",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <IndustryConfigPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/pipeline-config",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <IndustryConfigPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/projects",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <ProjectsSettingsPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/workflows",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <WorkflowsPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/workflows/new",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <WorkflowBuilderPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/workflows/:id/edit",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <WorkflowBuilderPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/ai-agent",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <BotIdentityPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/knowledge-base",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <KnowledgeBasePage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/profile",
    element: (
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;